import { __assign } from 'tslib';
import * as React from 'react';
import { useState, useEffect } from 'react';
import { Box, FormControl, InputLabel, Select, Skeleton } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import DefaultIcon from '../../DefaultIcon/index.js';
import FolderHeader from './FolderHeader/index.js';
import FolderItem from './FolderItem/index.js';
import NoResultFilterFolder from './NoResultFilterFolder/index.js';

var FilterFolder = function (_a) {
    var folderList = _a.folderList, onSelectFolder = _a.onSelectFolder, onGoToParent = _a.onGoToParent, onGoToChildren = _a.onGoToChildren, showElementCount = _a.showElementCount, currentFolder = _a.currentFolder, parentFolder = _a.parentFolder, selectedFolder = _a.selectedFolder, _b = _a.KIcon, KIcon = _b === void 0 ? DefaultIcon : _b, _c = _a.testId, testId = _c === void 0 ? "FilterFolder" : _c, className = _a.className, _d = _a.id, id = _d === void 0 ? "FilterFolder" : _d, style = _a.style, sx = _a.sx, _e = _a.navigationDown, navigationDown = _e === void 0 ? true : _e, loadingFolders = _a.loadingFolders, _f = _a.isFolderListVisible, isFolderListVisible = _f === void 0 ? false : _f;
    var t = useTranslation("refront-components").t;
    var _g = useState(isFolderListVisible), isFolderListOpened = _g[0], setIsFolderListOpened = _g[1];
    var _h = useState(navigationDown), isNavigationDown = _h[0], setIsNavigationDown = _h[1];
    var _j = useState(""), selectedValue = _j[0], setSelectedValue = _j[1];
    useEffect(function () {
        setIsNavigationDown(isNavigationDown);
    }, [isNavigationDown]);
    useEffect(function () {
        setIsFolderListOpened(isFolderListVisible);
    }, [isFolderListVisible]);
    useEffect(function () {
        setSelectedValue((currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.id) || t("filter.folder.select.default.placeholder"));
    }, [currentFolder, t]);
    var handleOnGoToChildren = function (e, folder) {
        e.stopPropagation();
        e.preventDefault();
        onGoToChildren(folder);
    };
    var handleOnGoToParent = function (e) {
        e.stopPropagation();
        e.preventDefault();
        onGoToParent();
    };
    var handleOnSelectFolder = function (folder) {
        onSelectFolder(folder);
        setSelectedValue(folder.id);
    };
    return (React.createElement(Box, { className: clsx("FilterFolder", className), "data-testid": testId, id: id, style: style, sx: __assign({ width: "100%", "& .MuiInputBase-formControl": { maxHeight: function (theme) { return theme.spacing(5); } }, ".MuiOutlinedInput-input": { fontSize: "0.875rem", height: "inherit" }, ".MuiInputLabel-root": {
                fontSize: "0.875rem"
            } }, sx) },
        React.createElement(FormControl, { fullWidth: true },
            React.createElement(InputLabel, { id: "filter-folder-input-label", sx: { paddingRight: function (theme) { return theme.spacing(2); } }, "aria-placeholder": t("filter.folder.select.default.placeholder") }, selectedFolder && t("filter.folder.select.default.placeholder")),
            React.createElement(Box // Need this wrapper for accessibility
            , { tabIndex: 0, onKeyDown: function (e) {
                    if (e.key === "Enter") {
                        setIsFolderListOpened(function (prev) { return !prev; });
                    }
                    else if (e.key === "Escape") {
                        setIsFolderListOpened(false);
                    }
                }, sx: {
                    minWidth: "100%",
                    maxWidth: {
                        xs: "calc(75vw - 32px)",
                        sm: "calc(30vw - 32px)",
                        md: "calc(25vw - 46px)"
                    }
                } },
                React.createElement(Select, { "data-testid": "FilterFolderSelect", labelId: "filter-folder-select-label", id: "filter-folder-select", value: selectedValue, onClick: function () { return setIsFolderListOpened(function (prev) { return !prev; }); }, open: isFolderListOpened, label: selectedFolder && t("filter.folder.select.default.placeholder"), sx: { fontSize: "0.875rem", width: "100%" }, renderValue: function () {
                        return selectedFolder ? selectedFolder.title : t("filter.folder.select.default.placeholder");
                    }, MenuProps: {
                        disableAutoFocusItem: true,
                        PaperProps: {
                            "aria-labelledby": "filter-folder-select-label"
                        },
                        sx: {
                            "& .MuiPaper-root": {
                                maxHeight: "40vh",
                                overflowY: "auto",
                                overflowX: "hidden",
                                maxWidth: {
                                    xs: "calc(75vw - 32px)",
                                    sm: "calc(30vw - 32px)",
                                    md: "calc(25vw - 46px)"
                                }
                            },
                            "& .MuiMenu-list": { padding: 0 }
                        },
                        elevation: 3
                    } },
                    currentFolder && (React.createElement(FolderHeader, { parentFolder: parentFolder, currentFolder: currentFolder, onGoToParent: handleOnGoToParent, KIcon: KIcon })),
                    currentFolder && !loadingFolders && !(currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.hasChildren) && (React.createElement(NoResultFilterFolder, null)),
                    loadingFolders && (React.createElement(Box, { "data-testid": "filterFolderSkeletonContainer", sx: { padding: function (theme) { return theme.spacing(0, 1, 0.5, 1); } } },
                        React.createElement(Skeleton, { variant: "text", height: 28, animation: "wave" }),
                        React.createElement(Skeleton, { variant: "text", height: 28, animation: "wave" }),
                        React.createElement(Skeleton, { variant: "text", height: 28, animation: "wave" }),
                        React.createElement(Skeleton, { variant: "text", height: 28, animation: "wave" }))),
                    folderList.map(function (folder, i) { return (React.createElement(FolderItem, { key: folder.id, folder: folder, onSelectFolder: handleOnSelectFolder, onGoToChildren: handleOnGoToChildren, showElementCount: showElementCount, KIcon: KIcon, navigationDown: navigationDown, isFirstItem: i === 0 && isFolderListOpened })); }))))));
};

export { FilterFolder as default };
//# sourceMappingURL=index.js.map
